document.addEventListener('DOMContentLoaded', () => {
	// Initialize MutationObserver to track changes in the cart
	const observer = new MutationObserver((mutationsList, observer) => {
	  mutationsList.forEach(mutation => {
		if (mutation.type === 'childList') {
		  // Track addition or removal of items in the cart
		  if (mutation.addedNodes.length || mutation.removedNodes.length) {
			updateAddToCartButtons();
		  }
		}
	  });
	});
  
	// Configure the observer to monitor cart elements
	observer.observe(document.querySelector('#CartDrawer'), {
	  childList: true, // Monitor the addition/removal of child elements
	  subtree: true // Monitor changes within the subtree, i.e., inside the cart
	});
  
	// Function to update the state of "Add to Cart" buttons
	function updateAddToCartButtons() {
	   // Get cart data
	  fetch('/cart.js')
		.then(response => response.json())
		.then(cart => {
		  // Iterate through all product cards
		  document.querySelectorAll('form[data-type="add-to-cart-form"]').forEach(form => {
			const productId = form.querySelector('input[name="id"]').value; // Product variant ID
			const button = form.querySelector('button[name="add"]'); // Add to cart button
			const span = button.querySelector('span'); // Find <span> inside the button
  
			// Check if this product is in the cart
			const isInCart = cart.items.some(item => item.id == productId);
  
			if (isInCart) {
			  // If the product is in the cart, change the text inside <span> and disable the button
			  span.textContent = 'Προστέθηκε';
			  button.disabled = true;
			  button.setAttribute('aria-disabled', 'true');
			  button.classList.add('btn-disabled'); // Class for styling the disabled button
			} else {
			  // If the product is not in the cart, restore the text inside <span> and enable the button
			  span.textContent = 'Προσθήκη';
			  button.disabled = false;
			  button.removeAttribute('aria-disabled');
			  button.classList.remove('btn-disabled');
			}
		  });
		})
		.catch(error => console.error('Error fetching cart:', error));
	}
  
	// Initialize the initial state of the buttons
	updateAddToCartButtons();
  });

  